import { useDataSubjectsQuery } from "@common/hooks/useSelectableItemQueries.ts";

export function useIncidentLogDataSubjectsField(isPreview: boolean) {
    const { isLoading, data } = useDataSubjectsQuery(!isPreview);

    return { isLoading, dataSubjects: data };
}
